import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConstant } from 'src/app/app.constant';
import { map } from 'rxjs/operators';

@Injectable()
export class ViewProfileCardService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(private httpClient: HttpClient, private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl();
    }
    manageStudentLogs(data) {
        return this.httpClient.post(`${this.apiUrl}/manageStudentLogs`, data).pipe(
            map((response: any) => {
                return response;
            })
        )
    }
    getUserProfile() {
        return this.httpClient.get(`${this.apiUrl}/getUserProfile/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                };
            })
        ) as any as any;
    }
    updateUserProfile(user) {
        return this.httpClient.post(`${this.apiUrl}/updateUserProfile`, user).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    getUserProfileById(userId) {
        return this.httpClient.get(`${this.apiUrl}/getUserProfileById/` + userId).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                };
            })
        ) as any as any;
    }

    getStudentLogs(id: number) {        
        return this.httpClient.get(`${this.apiUrl}/getAllStudentLogs/` + id).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                };
            })
        ) as any as any;
    }
    
}
